import React, { Component } from "react";
import config from './config';
import Button from '@material-ui/core/Button';
import PaymentMethod from "./PaymentMethod";

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css';

import CircularProgress from '@material-ui/core/CircularProgress';

import { motion } from "framer-motion";

import InternetNotAvailable from './InternetNotAvailable';
import MarkAsReadPopup from './popup/MarkAsReadPopup';
import ContinuePopup from './popup/ContinuePopup';
import MoreCashbackPopup from './popup/MoreCashbackPopup';

import DeviceConnectionPopup from './popup/DeviceConnectionPopup';

import Card from '@material-ui/core/Card';


import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';

// Importing toastify module
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import $ from "jquery";
import { Tune } from "@material-ui/icons";

// toast.configure()

export default class AdsMarkAsReadInstall extends Component {
    constructor(props) {
        super(props)

        var currentTimeline = "";
        var isBlinkShopOnline = true;
        var fiActivityId = 0;
        fiActivityId = this.props.match.params.fiActivityId;
        localStorage.setItem('fiHighlightActivity', fiActivityId);
        this.state = {
            fiActivityId: fiActivityId,
            currentTimeline: currentTimeline,
            fbShopOnlineLinkLoader: false,
            isDisableMarkAsRead: isBlinkShopOnline,
            isLoading: true,
            isBlinkButton: isBlinkShopOnline,
            isOpenContinuePopup: false,
            currentOffer: 1000,
            activeLocation: "",
            isOpenPopup: false,
            isDisplayLocations: false,
            popupContent: "",
            fbIsMyCashPopup: false,
            fbIsDevicePopupEnable: false
        }

        this.goBack = this.goBack.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);
        this.updateMarkAsRead = this.updateMarkAsRead.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.openPopup = this.openPopup.bind(this);
        this.blinkDisable = this.blinkDisable.bind(this);
        this.closePopupAndRedirectToLink = this.closePopupAndRedirectToLink.bind(this);
        this.copyOfferToClipBoard = this.copyOfferToClipBoard.bind(this);
        this.withOutApiGoTimelineWithBillPopup = this.withOutApiGoTimelineWithBillPopup.bind(this);
        this.closeDevicePopup = this.closeDevicePopup.bind(this);
        this.scrollToRef = this.scrollToRef.bind(this);
    }

    scrollToRef = (ref) => { window.scrollTo(0, $('.' + ref).offset().top); this.setState({ activeLocation: ref }) }
    closeDevicePopup(mutipleDeviceOpenStatus) {
        if (mutipleDeviceOpenStatus === 1) {
            this.goBack();
        } else if (mutipleDeviceOpenStatus === 2) {
            this.setState({ 'fbIsDevicePopupEnable': false, 'isOpenContinuePopup': true })
        } else {
            this.setState({ 'fbIsDevicePopupEnable': false })
        }
    }

    componentDidMount() {
        var requestParams = {
            'fsAction': 'getActivityDetails',
            'fiActivityId': this.state.fiActivityId
        };
        config.fetchInformation(requestParams).then((responseJson) => {
            this.setState({
                isLoading: false,
                isBlinkButton: responseJson.foActivity.fbIsBlinkShopOnline,
                currentTimeline: responseJson.foActivity
            });
        });

        var foGlobalSetting = JSON.parse(localStorage.getItem('foGlobalSetting'));

        let mid = foGlobalSetting.fsPaytmMID; // Merchant ID
        var url = foGlobalSetting.fbPaytmProd ? 'securegw.paytm.in' : 'securegw-stage.paytm.in';

        const script = document.createElement("script");
        script.async = false;
        script.src = 'https://' + url + "/merchantpgpui/checkoutjs/merchants/" + mid + '.js';
        document.body.appendChild(script);
    }

    withOutApiGoTimelineWithBillPopup() {
        this.props.history.push({
            pathname: '/my-timeline',
            state: { currentTimeline: this.state.currentTimeline, openBillUploadPopup: true }
        });
    }

    copyOfferToClipBoard(key) {
        config.updateUserSession('offer_online', this.state.currentTimeline.fiAdId);
        var couponDetails = this.state.currentTimeline.foCouponList[key];

        if (couponDetails.fsCouponCode != "") {
            this.copyToClipboard(couponDetails.fsCouponCode);
            toast.success('Code copied!', {
                position: "bottom-left"
            });
        }

        if (this.state.currentTimeline.fiAdCouponType === 1) {
            // window.open(couponDetails.fsCouponLink, '_blank');
            try {
                this.openLinkOnBrowser(couponDetails.fsCouponLink);
            } catch (error) {
                console.log(error);
            }
        } else {
            this.setState({
                isOpenContinuePopup: true,
                currentOffer: key
            });
        }
    }

    copyToClipboard(fsCouponCode) {
        var fsProvider = config.getProviderReferral();
        if (fsProvider === 'M91APP') {
            try {
                window.JSBridgePlugin.copyToClipboard(fsCouponCode);
            } catch (error) {
                console.log(error);
            }
        } else if (fsProvider === 'FATAKP') {
            try {
                window.ReactNativeWebView.postMessage(fsCouponCode);
            } catch (error) {
                console.log(error);
            }
        } else {
            try {
                window.app.setClipboard(fsCouponCode);
            } catch (error) {
                console.log(error);
            }
        }
        navigator.clipboard.writeText(fsCouponCode);
    }

    openLinkOnBrowser(fsCouponLink) {
        var fsProvider = config.getProviderReferral();
        if (fsProvider === 'M91APP') {
            try {
                window.JSBridgePlugin.openInBrowser(fsCouponLink);
            } catch (error) {
                console.log(error);
            }
        } else if (fsProvider === 'FATAKP') {
            try {
                window.ReactNativeWebView.postMessage(fsCouponLink);
            } catch (error) {
                console.log(error);
            }
        } else {
            try {
                window.app.openLinkOnBrowser(fsCouponLink);
            } catch (error) {
                console.log(error);
            }
        }

        if (config.getProviderSetting().fbIsPWAOpenOnWeb) {
            window.open(fsCouponLink, '_blank');
        }

    }

    closePopupAndRedirectToLink() {
        this.blinkDisable(false);
        this.setState({ fbShopOnlineLinkLoader: true });

        /* Clear blink */
        var currentTimeline = this.state.currentTimeline;
        currentTimeline.fbIsBlinkShopOnline = false;
        // this.props.history.push({
        //     pathname: '/ads-mark-as-read/'+this.state.fiActivityId,
        // });
        var fsProvider = config.getProviderReferral();
        if (this.state.currentOffer === 1000) {
            if (fsProvider === 'M91APP') {
                this.openLinkOnBrowser(this.state.currentTimeline.fsShopOnlineLink);
            } else {
                window.open(this.state.currentTimeline.fsShopOnlineLink, '_blank');
            }
        } else {
            var couponDetails = this.state.currentTimeline.foCouponList[this.state.currentOffer];
            if (couponDetails.fsCouponCode !== "") {
                // console.log(couponDetails.fsCouponCode);
                this.copyToClipboard(couponDetails.fsCouponCode);
            }
            // if(fsProvider==='M91APP'){
            this.openLinkOnBrowser(couponDetails.fsCouponLink);
            // }else{
            //     window.open(couponDetails.fsCouponLink, '_blank');
            // }
        }

        setTimeout(() => {
            this.setState({ isOpenContinuePopup: false, fbShopOnlineLinkLoader: false });
            this.goBack();
        }, 10000);
    }

    blinkDisable(isShopOnlineSession = true) {

        var requestParams = {
            "fsAction": "updateShopOnlineBlink",
            "fiActivityId": this.state.currentTimeline.fiActivityId
        };
        config.fetchInformation(requestParams).then((responseJson) => {
            console.log('Blonk Updated', responseJson);
        });

        var isDisableMarkAsRead = true;
        var enableReadPinPopup = false;
        if (this.state.currentTimeline.fsPinColor === 'green') {
            isDisableMarkAsRead = false;
            var enableReadPinPopup = true;
        }
        if (this.state.currentTimeline.fiAdCouponType === 1) {
            enableReadPinPopup = false;
            this.openLinkOnBrowser(this.state.currentTimeline.fsShopOnlineLink);
        }
        this.setState({ isDisableMarkAsRead: isDisableMarkAsRead, 'isBlinkButton': false, 'isDisplayLocations': true, isOpenContinuePopup: enableReadPinPopup, currentOffer: 1000 });
        if (isShopOnlineSession) {
            config.updateUserSession('shop_online', this.state.currentTimeline.fiAdId);
        }
    }

    handleClose() {
        this.setState({ 'isOpenPopup': false })
    }

    openPopup() {
        this.setState({ 'isOpenPopup': true })
    }

    updateMarkAsRead() {
        this.setState({ isLoading: true });
        var requestParams = {
            "fsMobile_number": localStorage.getItem('PhonePrefix').trim() + localStorage.getItem('userPhone'),
            "fsAd_Id": this.state.currentTimeline.ad_id
        };
        var formBody = config.convertParams(requestParams);
        var request = config.getRequestHeaders();
        fetch(config.API_URL + 'Update_MarketingAdsUsedStatus&' + formBody, request)
            .then((response) => response.text())
            .then((responseText) => {
                // this.props.history.push({
                //     pathname: '/my-timeline',
                //     state:{ }
                // });

                this.withOutApiGoTimelineWithBillPopup();
            });
    }

    handlePasswordChange(e) {
        const value = e.target.value;
        if (value === this.state.currentTimeline.fsGiftCardUsedPassword) {
            this.setState({ isDisableMarkAsRead: false });
        } else {
            this.setState({ isDisableMarkAsRead: true });
        }
    }

    handlePhoneChange(phone) {
        phone = phone.replace('+', '-');
        if (phone === localStorage.getItem('userPhone')) {
            this.setState({ isDisableMarkAsRead: false });
        } else {
            this.setState({ isDisableMarkAsRead: true });
        }
    }

    goBack() {
        this.props.history.push({
            pathname: '/my-timeline'
        });
    }

    toggleCouponPurchase(key) {
        let style = document.querySelector('.onlineOfferItem.location-' + key).parentElement.parentElement.lastChild.getAttribute('style');
        if (style === 'display: block;') {
            document.querySelector('.onlineOfferItem.location-' + key).parentElement.parentElement.lastChild.style.display = 'none';
        } else {
            document.querySelector('.onlineOfferItem.location-' + key).parentElement.parentElement.lastChild.style.display = 'block';
        }
    }

    render() {

        /* No Internet */
        if (!navigator.onLine) {
            return (
                <InternetNotAvailable />
            )
        }

        if (this.state.isLoading) {
            return (
                <div className="apiCallLoader fullScreenLoader">
                    <CircularProgress color="secondary" />
                </div>
            );
        }

        var onlineOfflineText = this.state.currentTimeline.fsPinColor === 'green' ? 'Online' : 'Offline';
        var shopOnlineText = 'Locate Nearby Stores';
        if (this.state.currentTimeline.fsPinColor === 'green') {
            shopOnlineText = "Shop Now";
            if (this.state.currentTimeline.fbIsLabelOrderNow === 1) {
                shopOnlineText = "Order Now";
            }
            if (this.state.currentTimeline.fbIsLabelOrderNow === 2) {
                shopOnlineText = "Pay Now";
            }
            if (this.state.currentTimeline.fbIsLabelOrderNow === 3) {
                shopOnlineText = "Mark as Used";
            }
            if (this.state.currentTimeline.fbIsLabelOrderNow === 4) {
                shopOnlineText = "Install Now";
            }
        }

        var shopOnlineLink = config.getTextFirstLink(this.state.currentTimeline.fsCouponDescription);
        if (this.state.currentTimeline.fsShopOnlineLink !== "") {
            shopOnlineLink = this.state.currentTimeline.fsShopOnlineLink;
        }

        if (localStorage.getItem('fbIsMobileConnected') === 'true' || this.state.currentTimeline.fsPinColor === 'red') {
            var shopOnlineLinkHtml = <div href={shopOnlineLink} rel="noopener noreferrer" target="_blank" onClick={this.blinkDisable}>{shopOnlineText}</div>;
        } else {
            var shopOnlineLinkHtml = <div href={shopOnlineLink} rel="noopener noreferrer" target="_blank" onClick={() => this.setState({ 'fbIsDevicePopupEnable': true })}>{shopOnlineText}</div>;
        }
        var shopClasses = 'Coupon ShopOnline box-shadow ';
        if (shopOnlineLink !== "") {
            shopClasses = shopClasses + 'active';
            if (this.state.isBlinkButton) {
                shopClasses = shopClasses + ' blink_me';
            }
        }

        var fsPopupTitle = config.getGlobalCashbackString().toUpperCase() + " TASK ACTIVATED";
        var fsButtonTxt = 'DO THE TASK';
        var deliveryPopupMessage = '<span style="font-size:14px !important;">\
                        AFTER YOU HAVE COMPLETED,<br/>\
                        YOUR TASK, PLEASE GIVE IT<br/>\
                        BETWEEN 5 MINS TO MAX 1 DAY <br/>\
                        BEFORE YOU GET CREDIT<br/>\
                        </span>';
        if (this.state.fbIsMyCashPopup === true) {
            var fsPopupTitle = 'EARN OR BUY ' + config.getGlobalCashbackString().toUpperCase();
            var fsButtonTxt = 'GOT IT';
            var deliveryPopupMessage = '<span style="font-size:14px !important;">\
                            You Need MyCash to Avail Offers.<br/>\
                            Complete a Task or Simply Buy it<br/>\
                            </span>';
        }

        var shopAsUsualText = "SHOP AS USUAL";
        if (this.state.currentTimeline.fsInstallRegisterType === 'register-purchase') {
            shopAsUsualText = 'REGISTER AS USUAL';
        } else if (this.state.currentTimeline.fsInstallRegisterType === 'install-purchase') {
            shopAsUsualText = 'INSTALL AS USUAL';
        }
        if (this.state.currentTimeline.fbIsLabelOrderNow === 1) {
            shopAsUsualText = "Order As Usual";
        }
        if (this.state.currentTimeline.fbIsLabelOrderNow === 2) {
            shopAsUsualText = "Pay Now";
        }

        var CouponBg = config.getProviderSetting().fsCouponImg;
        return (
            <motion.div
                initial="initial"
                animate="in"
                exit="out"
                variants={config.pageAnimation}
                transition={config.pageTransition}
            >
                {this.state.fbIsDevicePopupEnable ? <DeviceConnectionPopup popupContent="To create your account for<br/>Cashback Credit" closeDevicePopup={this.closeDevicePopup} /> : ''}

                {this.state.isOpenPopup ? <MarkAsReadPopup updateMarkAsRead={this.updateMarkAsRead} handleClose={this.handleClose} popupContent={this.state.popupContent} openDialog={true} /> : ''}

                {this.state.isOpenContinuePopup ?
                    <ContinuePopup popupButtonText={this.state.fbShopOnlineLinkLoader ? 'Please wait...' : fsButtonTxt}
                        popupTitle={fsPopupTitle}
                        popupContent={deliveryPopupMessage}
                        secondLineText=""
                        handleClose={this.closePopupAndRedirectToLink} openDialog={true} /> : ''}

                {this.state.isOpenContinuePopup || this.state.fbIsMyCashPopup ?
                    <ContinuePopup popupButtonText={this.state.fbShopOnlineLinkLoader ? 'Please wait...' : fsButtonTxt}
                        popupTitle={fsPopupTitle}
                        popupContent={deliveryPopupMessage}
                        secondLineText=""
                        handleClose={(this.state.fbIsMyCashPopup)
                            ? () => { this.setState({ fbIsMyCashPopup: false }) }
                            : this.closePopupAndRedirectToLink} openDialog={true} /> : ''}

                <ToastContainer theme="colored" position="bottom-left" />
                <div className="AppDashboard markAsReadScreen">
                    <div className="screenPadding">
                        <div className="markAsReadBack">
                            <span style={{ 'fontSize': '24px', 'marginTop': '-2px' }} className="material-icons-outlined" onClick={this.goBack}>keyboard_backspace</span>
                        </div>
                        <div className="MainTitle">
                            <div className="onlineOfflineTitle">{onlineOfflineText} COUPON</div>
                        </div>

                        <div className="newOnlineCouponDesign">
                            <img src={CouponBg} />
                            <img className="brandLogo" src={config.getImageUrl(this.state.currentTimeline.fsAdLogo)} />
                            <div className="offer-name">{this.state.currentTimeline.fsAdName}</div>
                            <div className="extra-text">{'EARN NOW'}</div>
                            {this.state.currentTimeline.fsInstallRegisterType === 'register-purchase' ?
                                <div className="upto-dis text-design">
                                    <span className="no-transform">REGISTER</span>
                                    <span>{'&'}</span>
                                    <span>PURCHASE</span>
                                </div>
                                :
                                <div className="upto-dis text-design">
                                    <span className="no-transform">INSTALL</span>
                                    <span>{'&'}</span>
                                    <span>PURCHASE</span>
                                </div>
                            }
                            <div>
                                <div className="upto-other text-design">
                                    <span>Exact</span>
                                    <span className="normal-text">Rs. {this.state.currentTimeline.fsFlatCashBack}</span>
                                    <span>{config.getCashbackString(this.state.currentTimeline.fbIsMyCash)}</span>
                                </div>
                                <div className="max-cashback-amount">Install From Playstore Only</div>
                            </div>
                        </div>

                        {this.state.currentTimeline.fsPinColor === 'green' ? <div className={shopClasses}>
                            {shopOnlineLinkHtml}
                        </div> : ''}
                        <div className="DontForgotUploadBill">
                            <span style={{ "marginLeft": '-30px' }}>({config.getGlobalCashbackString()} Will Credit After Task is Tracked)
                                <span onClick={() => { this.setState({ 'fbIsMyCashPopup': true }) }} className="material-icons-outlined help-icon markAsReadInstall-help">help</span>
                            </span>
                        </div>

                        {this.state.currentTimeline.fiAdCouponType === 0 ?
                            <Card>
                                <div className="Description" dangerouslySetInnerHTML={{ __html: this.state.currentTimeline.fsOfferDetails }}>
                                </div>
                            </Card>
                            :
                            <div className="amazon-slider">
                                {SwiperCore.use([Autoplay])}
                                <Swiper
                                    spaceBetween={50}
                                    slidesPerView={1}
                                    navigation
                                    autoplay={{
                                        delay: 3000,
                                        disableOnInteraction: false
                                    }}
                                    pagination={{ clickable: false }}
                                    scrollbar={{ draggable: true }}
                                    onSwiper={(swiper) => console.log(swiper)}
                                    onSlideChange={() => console.log('slide change')}
                                >
                                    {this.state.currentTimeline.foCouponList.map((offerItem, key) => {
                                        if (offerItem.fsCouponBanner === "") { return <></> }
                                        return (
                                            <SwiperSlide key={key}>
                                                <div className="slideItems">
                                                    <img onClick={() => this.scrollToRef('location-' + key)} src={offerItem.fsCouponBanner} />
                                                </div>
                                            </SwiperSlide>
                                        )
                                    })}
                                </Swiper>
                            </div>
                        }

                        <div className="offerListMain">
                        </div>
                        {this.state.currentTimeline.fsPinColor === 'green' ? '' :
                            <div className={this.state.isBlinkButton ? 'passwordInput firstNameLastName disabledPassword' : 'passwordInput firstNameLastName'}>
                                {this.state.currentTimeline.fsGiftCardUsedPassword === "" ?
                                    <div className="OTPInput">
                                        <div>
                                            <PhoneInput
                                                country={'in'}
                                                autoFormat={false}
                                                countryCodeEditable={false}
                                                enableSearch={true}
                                                searchPlaceholder='Search Country'
                                                placeholder="Mobile No. to Mark as Used"
                                                onChange={(phone) => this.handlePhoneChange(phone)}
                                                disabled={this.state.isBlinkButton}
                                            />
                                        </div>
                                    </div>
                                    :
                                    <div className="passwordInput">
                                        <input type="number" disabled={this.state.isBlinkButton} placeholder="Gift Card Pin" className="form-control customNomberInput" onChange={(event) => this.handlePasswordChange(event)} />
                                    </div>
                                }
                            </div>
                        }
                        {this.state.currentTimeline.fsRemainDay !== "" ? <div className="Coupon validDays bgBlack colorRed">{this.state.currentTimeline.fsRemainDay}</div> : ''}
                    </div>
                </div>
            </motion.div>
        )

    }
}